import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ClipLoader } from "react-spinners";

import { IIndustry } from "../../types";
import { updateIndustryByAdmin } from "../../services/industriesService";

interface EditIndustryModalProps {
  industry: IIndustry;
  onClose: () => void;
}

const EditIndustryModal = ({ industry, onClose }: EditIndustryModalProps) => {
  const [name, setName] = useState(industry?.name || "");

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => updateIndustryByAdmin(industry._id, { name }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["industries"] });
      onClose();
    },
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    mutation.mutate();
  };

  return (
    <div className="fixed inset-0 p-2 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-96">
        <h2 className="text-xl mb-4">Edit Industry</h2>
        <form onSubmit={handleSubmit}>
          <label className="block mb-2 text-sm font-medium text-gray-700">
            Industry Name
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full mt-1 p-2 border rounded-md"
              disabled={mutation.isPending}
            />
          </label>

          <div className="flex justify-end mt-4">
            <button
              type="button"
              className="px-4 py-2 text-rose-500 rounded-lg text-sm"
              onClick={onClose}
              disabled={mutation.isPending}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 text-sm rounded-lg border ml-2 flex items-center justify-center"
              disabled={mutation.isPending}
            >
              {mutation.isPending ? <ClipLoader size={20} /> : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditIndustryModal;
